import { render, staticRenderFns } from "./CommonPlans.vue?vue&type=template&id=55a770c6&"
import script from "./CommonPlans.vue?vue&type=script&lang=js&"
export * from "./CommonPlans.vue?vue&type=script&lang=js&"
import style0 from "./CommonPlans.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CommonPlans.vue"
export default component.exports